// extracted by mini-css-extract-plugin
module.exports = {"formitemRow":"salesUserInfo_formitemRow__1B3qV","required":"salesUserInfo_required__3RqH1"};